import { type ReactNode, useEffect, useState } from 'react'

/** Defer closed dialogs without discarding their state after the first visit. */
const MountOnFirstOpen = ({ open, children }: { open: boolean, children: ReactNode }) => {
  const [hasOpened, setHasOpened] = useState(open)

  useEffect(() => {
    if (open) setHasOpened(true)
  }, [open])

  return open || hasOpened ? <>{children}</> : null
}

export default MountOnFirstOpen
